module.exports = __webpack_public_path__ + "static/book-marketer-right.9575e66d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/book-marketer-right.png
// module id = 1470
// module chunks = 168707334958949